(function () {
  var cfg = window.NF_SHaker || {};
  var SEUIL = (cfg.seuil || 0) * 100;                 // en centimes (0 = hors fenêtre)
  var GIFT = cfg.variante;
  var horsFenetre = !cfg.seuil || cfg.seuil <= 0;     // le verrou du cadeau reste actif
  var etatPrecedent = null;

  function euro(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  function lire(panier) {
    var ligne = null;
    var total = 0;
    panier.items.forEach(function (i) {
      if (String(i.variant_id) === String(GIFT)) { ligne = i; }
      else { total += i.line_price; }
    });
    return { ligne: ligne, total: total, ok: total >= SEUIL };
  }

  function carte() {
    var el = document.getElementById('nf-shaker-card');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'nf-shaker-card';
    el.innerHTML =
      '<div class="nf-sk__in"><p class="nf-sk__txt"></p>' +
      '<button type="button" class="nf-sk__btn"></button>' +
      '<button type="button" class="nf-sk__close" aria-label="Fermer">×</button></div>';
    document.body.appendChild(el);
    el.querySelector('.nf-sk__close').addEventListener('click', function () {
      el.dataset.ferme = '1'; el.style.display = 'none';
    });
    return el;
  }

  function rendre(p) {
    if (horsFenetre) {
      var deja = document.getElementById('nf-shaker-card');
      if (deja) deja.remove();
      return;
    }
    var el = carte();
    if (el.dataset.ferme === '1') return;
    var cle = (p.ligne ? 'in' : 'out') + '|' + p.ok + '|' + p.total;
    var txt = el.querySelector('.nf-sk__txt');
    var btn = el.querySelector('.nf-sk__btn');

    if (!p.ligne && p.ok) {
      txt.textContent = 'Votre panier dépasse ' + euro(SEUIL) + ' : le shaker en inox est offert.';
      btn.textContent = 'Ajouter le shaker offert';
      btn.style.display = '';
      btn.disabled = false;
      btn.onclick = function () {
        btn.disabled = true; btn.textContent = 'Ajout…';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: GIFT, quantity: 1 })
        }).then(function () { location.reload(); })
          .catch(function () { btn.disabled = false; btn.textContent = 'Réessayer'; });
      };
      el.className = 'nf-sk nf-sk--go';
    } else if (!p.ligne) {
      txt.textContent = 'Plus que ' + euro(SEUIL - p.total) + ' pour recevoir le shaker offert.';
      btn.style.display = 'none';
      el.className = 'nf-sk nf-sk--encours';
    } else if (!p.ok) {
      txt.textContent = 'Le shaker n’est offert qu’à partir de ' + euro(SEUIL) + '.';
      btn.textContent = 'Retirer le shaker';
      btn.style.display = '';
      btn.onclick = function () {
        btn.disabled = true;
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var l = c.items.filter(function (i) {
              return String(i.variant_id) === String(GIFT);
            })[0];
            if (!l) return null;
            return fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: l.key, quantity: 0 })
            });
          })
          .then(function () { location.reload(); })
          .catch(function () { btn.disabled = false; });
      };
      el.className = 'nf-sk nf-sk--alerte';
    } else {
      txt.textContent = 'Shaker en inox offert, ajouté à votre panier.';
      btn.style.display = 'none';
      el.className = 'nf-sk nf-sk--panier';
    }
    etatPrecedent = cle;
  }

  function masquerQuantiteCadeau() {
    document.querySelectorAll('.cart-item, [data-cart-item]').forEach(function (ligne) {
      if (!/shaker-en-inox/i.test(ligne.innerHTML)) return;
      ligne.querySelectorAll('.quantity, quantity-input, .quantity__input, button[name="plus"], button[name="minus"]')
        .forEach(function (el) { if (el.style.display !== 'none') { el.style.display = 'none'; } });
      if (!ligne.querySelector('.nf-sk-offert')) {
        var badge = document.createElement('span');
        badge.className = 'nf-sk-offert';
        badge.textContent = 'Offert';
        badge.style.cssText = 'display:inline-block;margin-left:8px;padding:2px 8px;border-radius:999px;' +
          'background:#13403A;color:#fff;font-size:11px;font-weight:600;letter-spacing:.04em;text-transform:uppercase';
        var ancre = ligne.querySelector('.cart-item__details, .cart-item__name, a');
        if (ancre) { ancre.appendChild(badge); }
      }
    });
  }

  function rafraichir() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var p = lire(panier);
        // le cadeau est unique : on ramène toute quantité supérieure à 1
        if (p.ligne && p.ligne.quantity > 1) {
          fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: p.ligne.key, quantity: 1 })
          }).then(function () {
            fetch('/cart.js', { cache: 'no-store' })
              .then(function (r2) { return r2.json(); })
              .then(function (maj) { rendre(lire(maj)); })
              .catch(function () {});
          }).catch(function () {});
          return;
        }
        rendre(p);
      })
      .catch(function () {});
  }

  var css = document.createElement('style');
  css.textContent =
    '.nf-sk{position:fixed;right:16px;bottom:104px;z-index:9998;max-width:330px;' +
    'background:#fff;border-radius:14px;box-shadow:0 12px 34px rgba(0,0,0,.18);' +
    'border:1px solid rgba(19,64,58,.12);font-size:14px;line-height:1.45;' +
    'transition:transform .25s ease, box-shadow .25s ease}' +
    '.nf-sk__in{position:relative;padding:14px 38px 14px 16px}' +
    '.nf-sk__txt{margin:0 0 9px;color:#13403A;font-weight:600}' +
    '.nf-sk__btn{background:#13403A;color:#fff;border:0;border-radius:999px;' +
    'padding:9px 18px;font-weight:600;cursor:pointer;font-size:14px}' +
    '.nf-sk__btn:hover{background:#0d2e29}' +
    '.nf-sk__close{position:absolute;top:4px;right:8px;background:none;border:0;' +
    'font-size:20px;line-height:1;color:#5F6B68;cursor:pointer}' +
    '.nf-sk--encours .nf-sk__txt{font-weight:500;color:#3A4A47}' +
    '.nf-sk--alerte{border-color:#E0B4A4}' +
    '.nf-sk--panier .nf-sk__txt{font-weight:500;color:#3A4A47}' +
    '.nf-sk--go{animation:nfPulse 2.2s ease-in-out infinite;border-color:rgba(40,167,166,.45)}' +
    '.nf-sk--go .nf-sk__btn{box-shadow:0 0 0 0 rgba(19,64,58,.45);animation:nfBtn 2.2s ease-in-out infinite}' +
    '@keyframes nfPulse{0%,100%{transform:scale(1);box-shadow:0 12px 34px rgba(0,0,0,.18)}' +
    '45%{transform:scale(1.022);box-shadow:0 14px 40px rgba(19,64,58,.25)}}' +
    '@keyframes nfBtn{0%,100%{box-shadow:0 0 0 0 rgba(19,64,58,.35)}' +
    '50%{box-shadow:0 0 0 8px rgba(19,64,58,0)}}' +
    '@media(prefers-reduced-motion:reduce){.nf-sk--go,.nf-sk--go .nf-sk__btn{animation:none}}' +
    '@media(max-width:520px){.nf-sk{left:12px;right:12px;bottom:96px;max-width:none}}';
  document.head.appendChild(css);

  function demarrer() {
    rafraichir();
    // le panier change sans rechargement (tiroir, ajout express) : on réécoute
    setInterval(rafraichir, 2000);
    document.addEventListener('visibilitychange', rafraichir);
    // le panier se redessine (tiroir, page panier) : on verrouille la ligne cadeau
    setInterval(masquerQuantiteCadeau, 1500);
    var minuteurObs = null;
    var obs = new MutationObserver(function () {
      if (minuteurObs) return;
      minuteurObs = setTimeout(function () { minuteurObs = null; masquerQuantiteCadeau(); }, 250);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('button[name="add"], .cart-drawer, [data-cart-drawer]')) {
        setTimeout(rafraichir, 900);
        setTimeout(rafraichir, 2200);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else { demarrer(); }
})();
